import React, { useState, useEffect, useRef, useCallback } from "react";
//import axios from "axios";
import "./ongoingorders.css";
import api from "../../services/api";
import { debounce } from "lodash";
//import OrderDetails from "./OrderDetails";

const OngoingOrders = ({ handleOrderSelect }) => {
  const [orders, setOrders] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const [isSearching, setIsSearching] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const ordersContainerRef = useRef(null); // Reference for scrolling
  const [page, setPage] = useState(1);
  const observer = useRef(null);

  // Debounced API call for searching
  const debounceSearch = useCallback(
    debounce(async (query) => {
      if (query) {
        setIsSearching(true);
      } else {
        setIsSearching(false);
        setPage(1);
        setOrders([]);
        fetchOrders();
        scrollToTop();
        return;
      }
      setLoading(true);
      try {
        const response = await api.post("/SearchOngoingOrders", {
          search: query,
        });
        setOrders(response.data.orders || []);
        scrollToTop(); // Scroll to top when new search results are loaded
      } catch (error) {
        console.error("Error searching ongoing orders:", error);
        setOrders([]);
      }
      setLoading(false);
    }, 1000),
    []
  );

  // Scroll to top function
  const scrollToTop = () => {
    if (ordersContainerRef.current) {
      ordersContainerRef.current.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  // Handle search input change
  const handleSearchChange = (e) => {
    const query = e.target.value;
    setSearch(query);
    debounceSearch(query);
  };

  // Function to fetch orders from API
  const fetchOrders = async () => {
    if (loading || isSearching) console.log(loading, isSearching);
    setLoading(true);
    try {
      const response = await api.post("/getAllOngooingOrders", {
        page,
        limit: 30,
      });
      setOrders((prevOrders) => [...prevOrders, ...response.data.orders]);
      setPage((prevPage) => prevPage + 1);
    } catch (error) {
      console.error("Error fetching orders:", error);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchOrders();
  }, []);

  // Infinite scroll logic (only works if not searching)
  const lastOrderRef = (node) => {
    if (loading || isSearching) return;
    if (observer.current) observer.current.disconnect();
    observer.current = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          fetchOrders();
        }
      },
      { threshold: 1.0 }
    );
    if (node) observer.current.observe(node);
  };
  const handleOrderClick = (order) => {
    // console.log("Selected Order:", order);
    setSelectedOrder(
      (prevSelected) =>
        prevSelected?.order_id === order.order_id ? null : { ...order } // Create a new object
    );
    if (order.order_id === selectedOrder?.order_id) {
      setSelectedOrder(null);
      handleOrderSelect(null);
    } else {
      handleOrderSelect(order);
    }
  };

  return (
    <div className="orders-container-OnGoingOrders">
      <h2 className="orders-title-OnGoingOrders">Ongoing Orders</h2>
      <hr />
      <div className="search-OnGoingOrders">
        <input
          type="text"
          placeholder="Search restaurant"
          value={search}
          onChange={handleSearchChange}
          className="orders-search"
        />
      </div>
      <div className="orders-list-OnGoingOrders" ref={ordersContainerRef}>
        {orders.map((order, index) => (
          <div
            key={index}
            className={`order-card-OnGoingOrders ${
              selectedOrder?.order_id === order.order_id ? "selected" : ""
            }`}
            ref={index === orders.length - 15 ? lastOrderRef : null}
            onClick={() => handleOrderClick(order)}
          >
            <h3 className="order-restaurant-OnGoingOrders">
              {order.restaurantName}
            </h3>
            <p className="order-details-OnGoingOrders">
              Order by: {order.orderdBy}
            </p>
            <div className="item-price-OnGoingOrders">
              <p className="order-details-OnGoingOrders">
                Total Items: {order.items.length}
              </p>
              <p className="order-price-OnGoingOrders">₹{order.subTotal}</p>
            </div>
          </div>
        ))}
      </div>
      {loading && <p>Loading more orders...</p>}
      {/* Order Details */}
      {/* <OrderDetails selectedOrder={selectedOrder} /> */}
    </div>
  );
};

export default OngoingOrders;
